<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 13:46:30
-->
<template>
    <div>
        <a-sub-menu :key="menuInfo.key">
            <template #icon>
                <component :is="$antIcons[menuInfo.icon]"></component>
            </template>
            <template #title>{{ $t(`${menuInfo.title_lang}`) }}</template>
            <template v-for="item in menuInfo.children" :key="item.key">
                <template v-if="!item.children">
                    <router-link :to="item.link">
                        <a-menu-item :key="item.key">
                            {{ $t(`${item.title_lang}`) }}
                        </a-menu-item>
                    </router-link>
                </template>
                <template v-else>
                    <sub-menu :menu-info="item" :key="item.key" />
                </template>
            </template>
        </a-sub-menu>
    </div>
</template>

<script setup>
    const props = defineProps({
        menuInfo:{
            type:Object,
            default:()=>({})
        },
    })
</script>

<style lang="scss" scoped>

</style>